<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: AppBadge
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { AppBadgeProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import { useAppBadge } from '../composables/use-app-badge.hook'

defineOptions({
  name: 'AppBadge',
})

const props = defineProps<AppBadgeProps>()

const { textColor } = useAppBadge({ props })
</script>

<template>
  <span :class="['app-badge', `app-badge--${color}`, { 'app-badge--with-icon': !!prependIcon }]">
    <AppIcon
      v-if="prependIcon"
      :icon="prependIcon"
      size="small"
    />
    <AppText
      name="body2"
      :color="textColor"
      tag="span"
    >
      {{ text }}
    </AppText>
  </span>
</template>

<style lang="scss" scoped src="../styles/_app-badge.scss" />
